/**
 * Build bulk update payload from copied drop values.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { BulkUpdatePreparedDropsPayload } from '@/hooks';
import type { DropApplyValues } from '@/stores/drop-apply.store';
import { filterSenderNamesMax11 } from '@/features/smswiser-campaigns/components/PrepareNewDropsForm';
import { resolveRouteId, resolveWiserId } from '@/features/smswiser-campaigns/components/SmswiserCampaignStatsTab/hooks/scale/resolvers';

export interface ApplyCopiedParams {
  values: DropApplyValues;
  campaigns: Array<{ id: number; name: string }>;
  gateways: Array<{ id: number; name: string }>;
}

export function buildApplyPayload(params: ApplyCopiedParams): BulkUpdatePreparedDropsPayload | null {
  const { values, campaigns, gateways } = params;
  const payload: BulkUpdatePreparedDropsPayload = {};

  if (values.campaignName?.trim()) {
    const wiserId = resolveWiserId(values.campaignName, campaigns);
    if (wiserId != null && wiserId > 0) payload.wiserId = wiserId;
  }

  if (values.gatewayName != null && values.gatewayName.trim()) {
    const routeId = resolveRouteId(values.gatewayName, gateways);
    if (routeId != null && routeId > 0) payload.routeId = routeId;
  }

  if (values.senderNames?.length) {
    payload.senderNames = filterSenderNamesMax11(values.senderNames).slice(0, 50);
  }

  if (values.smsTexts?.length) {
    payload.smsTexts = values.smsTexts.slice(0, 50);
  }

  const hasChanges =
    'wiserId' in payload ||
    'routeId' in payload ||
    (payload.senderNames?.length ?? 0) > 0 ||
    (payload.smsTexts?.length ?? 0) > 0;
  return hasChanges ? payload : null;
}
